<template>
    <div>
        <Header />
          
        <v-container class="d-flex justify-center align-center fill-height">
      <v-card class="text-center pa-1" >
  <v-card-text>
              <v-row>
                <v-col cols="12">
                <v-img :src="require('@/assets/images/pref.gif')" class="elevation-0" max-height="280"></v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-center" style="padding-top: 14px;">
                  <v-combobox
                  v-model="BranchCode"
                  :items="BranchCodeOptions"
                 label="Select Branch"
                 :disabled="IsDisableBarnch"
                 @change="GetBranchByBranchCode($event)"
                 dense
                ></v-combobox>
                </v-col>
                
                    <v-col cols="5" sm="5" md="5" v-show="HideItemCostDetails === false" style="text-align: left;padding-top: 0px !important;" >

                        <v-switch
                          
                         v-model="ShowCost"
                         label="Show Cost"
                         color="info"
                         hide-details
                         @change="UpdateSettingsValue('ShowCost',$event)"
                       ></v-switch>
                      
                     </v-col>

              
                <v-col cols="7" sm="7" md="7" style="text-align: right;padding-top: 0px !important;">
                  <v-switch
                   v-model="ShowSupplier"
                   label="Show Supplier"
                   color="info"
                   @change="UpdateSettingsValue('ShowSupplier',$event)"
                   hide-details
                 ></v-switch>
                </v-col>
                
              </v-row>
              <v-row>
<v-col cols="12" style="text-align: left;">
          
                <v-list
            style="margin-top:0px;margin-right: -20px;
    margin-left: -8px;"
          >
            <v-list-item-group v-model="item"  class="titlefont">
              <v-list-item color="primary">
                <v-list-item-content style="margin-left: -7px;">
                  <v-list-item-title
                    style="min-width:100px !important;
    white-space: normal"
                    >Use Automatically Generated Invoice No (Order)
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                v-model="IsAutoOrderInvoiceNo"
                   color="info"
                   hide-details
                 ></v-switch>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          </v-col>
              </v-row>
          <v-row v-if="IsAutoOrderInvoiceNo" style="padding-top:10px">
            <v-col cols="3" style="padding-top:0px;padding-bottom:0px">
              <v-text-field v-model="OrderPrefix" dense label="Prefix"  ></v-text-field>
            </v-col>
            <v-col cols="6" style="padding-top:0px;padding-bottom:0px">
              <v-text-field dense v-model="OrderNextNo" type="number" label="Invoice No"    ></v-text-field>
            </v-col>
            <v-col cols="3" style="padding-top:0px;padding-bottom:0px">
              <v-text-field dense v-model="OrderSuffix" label="Suffix"  ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
           <v-col
              cols="12"
              md="12"
              lg="12"
              style="text-align:center;padding-bottom: 12px;padding-top:12px"
              v-if="IsAutoOrderInvoiceNo"
            >
              <v-btn
              block
                style="background-color:#546E7A;color:#FFF;"
                @click="SetOrderInvoiceNo()"
                dark
              >
                Save <v-icon style="padding-left:8px">mdi-save</v-icon>
              </v-btn>

            </v-col>
          </v-row>
             <!--  <v-col cols="12" class="text-center" style="padding-top: 14px;">
                <v-btn color="info" class="mr-6" @click="save_preference">
                  Save
                </v-btn>
              </v-col> -->
              </v-card-text>
              </v-card>
            </v-container>
      <v-snackbar Bottom :timeout="timeout" :color="SnackbarColor"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 
   

    </div>
  </template>
  <script>
  
  import axios from "axios";
  import Header from "../Pages/Header.vue";
  export default {
    components: {
      Header
    },
    data() {
      return {
         bURL : localStorage.getItem('BaseURL'),
        ShowCost:false,
            HideItemCostDetails:true,
            ShowSupplier:false,
             BranchCodeOptions :JSON.parse(localStorage.getItem('Branches')),
             BranchCode : "",
             IsDisableBarnch : false,
             IsAutoOrderInvoiceNo:false,
             OrderPrefix :localStorage.getItem('OrderPrefix')?localStorage.getItem('OrderPrefix'): "",
             OrderNextNo : localStorage.getItem('OrderNextNo')?localStorage.getItem('OrderNextNo'): "",
             OrderSuffix : localStorage.getItem('OrderSuffix')?localStorage.getItem('OrderSuffix'): "",
             snackbar: false,
             SnackbarMessege: '',
             SnackbarColor:'green',
             timeout: 2000,
      };
    },
    mounted() {
       
        this.ShowCost = localStorage.getItem('ShowCost')
        if(this.ShowCost === null || this.ShowCost === 'null'  || this.ShowCost === undefined || this.ShowCost === "undefined" ||  this.ShowCost === false || this.ShowCost === "false")
        {
          this.ShowCost = false
        }
        else{
          this.ShowCost = true
        }
        
        this.ShowSupplier = localStorage.getItem('ShowSupplier')
        if(this.ShowSupplier === null || this.ShowSupplier === 'null' || this.ShowSupplier === undefined || this.ShowSupplier === "undefined" || this.ShowSupplier === false || this.ShowSupplier === "false")
        {
          this.ShowSupplier = false
        }
        else{
          this.ShowSupplier = true
        }

          this.BranchCode = localStorage.getItem('SystemBranch')
            if(this.BranchCode === "#" || this.BranchCode === "" || this.BranchCode === "null" || this.BranchCode === null ||this.BranchCode === undefined)
            {
              this.BranchCode = ""
            }
            
          this.UserDetails = JSON.parse(localStorage.getItem('User'))
          this.BranchCode1 = this.UserDetails.branchCode
          
          if(this.UserDetails.userType === "Administrator" || (this.UserDetails.userType !== "Administrator" && (this.BranchCode1 === "#" || this.BranchCode1 === "" || this.BranchCode1 === "null" || this.BranchCode1 === null)))
          {
            this.IsDisableBarnch = false
          }
          else{
            this.IsDisableBarnch = true
          }
          this.GetSettings()

          if(this.OrderNextNo !=="")
          {
             this.IsAutoOrderInvoiceNo = true
          }
    },
    methods: {
    
      UpdateSettingsValue(name,value)
      {
          localStorage.setItem(name,value)
      },
    GetBranchByBranchCode(branchCode)
    {
      localStorage.setItem('SystemBranch',branchCode)
      this.Loaderdialog = true
      axios
          .get(this.bURL+"/api/Branch/GetBranchByBranchCode?BranchCode=" +
            branchCode )
          .then(
            (response) => {
              this.Loaderdialog = false
              this.PriceGroupId = response.data.PriceGroupId
              localStorage.setItem("PriceGroupId",this.PriceGroupId)
             
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    GetSettings()
    {
       this.UserDetails = JSON.parse(localStorage.getItem('User'))
       axios.get(this.bURL + '/api/common/GetRoleSettingsDictionary?RoleName='+ this.UserDetails.userType)
        .then((response)  =>  {
          
             this.HideItemCostDetails = response.data.HideItemCostDetails
             if (this.HideItemCostDetails === "True") 
                this.HideItemCostDetails = true;
             else 
                this.HideItemCostDetails = false;
        }, (error)  =>  {
          console.log(error)
        })
    },
    SetOrderInvoiceNo()
    {
          localStorage.setItem("OrderPrefix",this.OrderPrefix)
          localStorage.setItem("OrderNextNo",this.OrderNextNo)
          localStorage.setItem("OrderSuffix",this.OrderSuffix)
          this.SnackbarColor = 'green'
          this.SnackbarMessege = "Saved"
          this.snackbar = true
    },
    }
  };
  </script>
  